import BaseModel from '../base/BaseModel.model';
import RolePermission from './rolePermission.model';

export default class Role extends BaseModel {

    public tipoRoleId?: number | null;
    public name?: string;
    public permissions : Array<RolePermission> = [];
    public disabled?: boolean;
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = 0;
        this.tipoRoleId = null;
        this.name = "";
        this.permissions = [];
        this.disabled = false;
    }
}